const SponsorRoutes = [
  {
    path: '/',
    name: 'Dashboard',
    component: () => import('./Dashboard.vue'),
    children: [
      {
        name: 'ProfileShowPage',
        path: '/profile',
        component: () => import('./pages/Profile/ProfileShowPage.vue'),
        children: [
          {
            name: 'MeShowPage',
            path: '/me',
            component: () => import('./pages/Profile/MeShowPage.vue')
          },
          {
            name: 'TeamShowPage',
            path: '/team',
            component: () => import('./pages/Profile/TeamShowPage.vue')
          },
          {
            name: 'PasswordEditPage',
            path: '/password',
            component: () => import('./pages/Profile/PasswordEditPage.vue')
          }
        ]
      },
      {
        name: 'OfferListPage',
        path: '/offers',
        component: () => import('./pages/Offer/OfferListPage.vue')
      },
      {
        name: 'OfferShowPage',
        path: '/offers/:offerId/:tab?',
        component: () => import('./pages/Offer/OfferShowPage.vue')
      },
      {
        path: '/offers/:offerId/advance/:advanceId/edit',
        name: 'AdvanceEditPage',
        component: () => import('./pages/Advance/AdvanceEditPage.vue')
      },
      {
        name: 'EventFeedListPage',
        path: '/event-feed',
        component: () => import('./pages/EventFeed/EventFeedListPage.vue'),
        children: [
          {
            name: 'EventFeedDetails',
            path: '/event-feed/:eventId',
            component: () => import('./pages/EventFeed/EventFeedDetails.vue')
          }
        ]
      },
      {
        name: 'EventScheduleListPage',
        path: '/schedule',
        component: () => import('./pages/EventSchedule/EventScheduleListPage.vue')
      },
      {
        path: '/campaigns',
        name: 'CampaignListPage',
        component: () => import('./pages/Campaign/CampaignListPage.vue')
      },
      {
        path: '/campaigns/create',
        name: 'CampaignCreatePage',
        component: () => import('./pages/Campaign/CampaignCreatePage.vue')
      },
      {
        path: '/campaigns/:campaignId',
        name: 'CampaignShowPage',
        component: () => import('./pages/Campaign/CampaignShowPage.vue'),
        redirect: { name: 'CampaignOverviewStage' },
        children: [
          {
            name: 'CampaignOverviewStage',
            path: '/campaigns/:campaignId/overview',
            component: () => import('@ui/Campaign/pipeline/Overview/CampaignOverviewStage.vue'),
            children: [
              {
                path: '/campaigns/:campaignId/overview/:step/edit',
                name: 'CampaignEditWizard',
                component: () => import('@ui/Campaign/CampaignEditWizard.vue')
              }
            ]
          },
          {
            name: 'CampaignEventFeedStage',
            path: '/campaigns/:campaignId/matches/:tab?',
            component: () => import('@ui/Campaign/pipeline/EventFeed/CampaignEventFeedStage.vue'),
            children: [
              {
                name: 'CampaignListingFeedListingShow',
                path: '/campaigns/:campaignId/matches/:tab?/listings/:listingId',
                component: () => import('@ui/Campaign/pipeline/AudienceListing/AudienceListingShow.vue'),
              },
              {
                name: 'CampaignListingFeedListingEdit',
                path: '/campaigns/:campaignId/matches/listings/:listingId/edit',
                component: () => import('@ui/Campaign/pipeline/AudienceListing/CampaignFeedListingEdit.vue'),
              }
            ]
          },
          {
            name: 'CampaignCheckoutStage',
            path: '/campaigns/:campaignId/checkout',
            component: () => import('@ui/Campaign/pipeline/Checkout/CampaignCheckoutStage.vue'),
            children: [
              {
                name: 'CampaignCheckoutListingShow',
                path: '/campaigns/:campaignId/checkout/listings/:listingId',
                component: () => import('@ui/Campaign/pipeline/AudienceListing/AudienceListingShow.vue'),
              },
              {
                name: 'CampaignCheckoutListingEdit',
                path: '/campaigns/:campaignId/checkout/listings/:listingId/edit',
                component: () => import('@ui/Campaign/pipeline/Checkout/CampaignCheckoutListingEdit.vue'),
              },
              {
                name: 'CampaignCheckoutVendorListingShow',
                path: '/campaigns/:campaignId/checkout/pro-services/:vendorListingId',
                component: () => import('@ui/VendorListing/VendorListingShow.vue'),
              }
            ]
          },
          {
            name: 'CampaignScheduleStage',
            path: '/campaigns/:campaignId/schedule',
            component: () => import('@ui/Campaign/pipeline/Schedule/CampaignScheduleStage.vue')
          },
        ]
      },
      {
        path: '/campaigns/:campaignId/edit',
        name: 'CampaignEditPage',
        component: () => import('@modules/sponsor/pages/Campaign/CampaignEditPage.vue')
      },
      {
        path: '/events/:eventId',
        name: 'EventShowPage',
        component: () => import('@modules/sponsor/pages/Event/EventShowPage.vue')
      }
    ]
  },
  {
    path: '/welcome',
    name: 'OnboardSponsor',
    component: () => import('@modules/sponsor/pages/OnboardSponsor.vue')
  },
  {
    path: '/wait-list',
    name: 'WaitListSponsor',
    component: () => import('@modules/sponsor/pages/WaitListSponsor.vue')
  },
  {
    path: '*',
    redirect: '/'
  }
]

export default SponsorRoutes